// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"SendResultsByEmail_iconSync__2y-pV","fa-spin":"SendResultsByEmail_fa-spin__1eifN","accordionHeader":"SendResultsByEmail_accordionHeader__39qQY"};